import axios from "axios";
import qs from "qs";

const base = process.env.REACT_APP_BASE_SERVER;

// a tiny axios instance so we don't repeat configs
const http = axios.create({
    withCredentials: true,
});

// NOTE: for GET with array params like scope[], use this
const qsBrackets = (params) =>
    qs.stringify(params, { arrayFormat: "brackets" });

/** Companies */
export async function fetchCompanies() {
    const { data } = await http({
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: qs.stringify({}),
        url: `${base}/client/company`,
    });
    if (data?.success) return data.data || [];
    return [];
}

/** Categories (supports scopes array -> "scope[]") */
export async function fetchCategories(scopes = [], clientId = "") {
    const params = { "scope[]": scopes };
    if (clientId) params.clientId = clientId;

    const { data } = await http.get(`${base}/api/v2/emission-category`, {
        params,
        paramsSerializer: qsBrackets,
    });
    if (data?.ok) return data.data || [];
    return [];
}

/** Offices by company */
export async function fetchOffices(companyId) {
    const { data } = await http({
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: qs.stringify({ coid: companyId }),
        url: `${base}/client/office`,
    });
    if (data?.success) return data.data || [];
    return [];
}

/** Emission factors by category */
export async function fetchEmissionFactors(categoryId, clientId = "", includeFactorId = null) {
    const params = { categoryId };
    if (clientId) params.clientId = clientId;
    if (includeFactorId) params.includeFactorId = includeFactorId;

    const { data } = await http.get(`${base}/api/v2/emission-factor`, {
        params,
    });
    if (data?.ok) return data.data || [];
    return [];
}

/** Create emission record (multipart) */
export async function createEmissionRecord(payload = {}, file = null) {
    const form = new FormData();
    // required/common
    if (payload.scope != null) form.append("scope", String(payload.scope));
    if (payload.category != null) form.append("category", String(payload.category));
    if (payload.factor != null) form.append("factor", String(payload.factor));
    if (payload.unit != null) form.append("unit", String(payload.unit));
    if (payload.company != null) form.append("company", String(payload.company));
    if (payload.location != null) form.append("location", String(payload.location));
    if (payload.assets != null) form.append("assets", payload.assets);
    if (payload.date != null) form.append("date", payload.date);
    if (payload.amount != null) form.append("amount", String(payload.amount));

    // optional (category 26)
    if (payload.amount_2 != null) form.append("amount_2", String(payload.amount_2));
    if (payload.amount_3 != null) form.append("amount_3", String(payload.amount_3));
    if (payload.clientId != null && String(payload.clientId).trim() !== "") {
        form.append("clientId", String(payload.clientId));
        form.append("client_id", String(payload.clientId));
    }

    if (file) form.append("attachment", file);

    const { data } = await http({
        method: "POST",
        headers: { "content-type": "multipart/form-data" },
        data: form,
        url: `${base}/emission/create`,
    });

    return !!data?.success;
}

export async function readEmissionRecord(id) {
    const form = new FormData();
    form.append("id", id);
    const r = await axios({
        withCredentials: true,
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: form,
        url: `${base}/emission/read`,
    });
    return r?.data?.success ? r.data.data?.[0] : null;
}

export async function updateEmissionRecord(formData) {
    const r = await axios({
        withCredentials: true,
        method: "POST",
        headers: { "content-type": "multipart/form-data" },
        data: formData,
        url: `${base}/emission/update`,
    });
    return !!r?.data?.success;
}

export async function emissionBulkInsert(formData) {
    const r = await axios({
        withCredentials: true,
        method: "POST",
        headers: { "content-type": "multipart/form-data" },
        data: formData,
        url: `${base}/emission-bulk-insert`,
    });
    return r?.data || null;
}
